import styled from 'styled-components';

import { rem } from '../../utils';

export const StyledEmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: ${({ theme }) => rem(theme.Spacing.Size.Large)};
`;
